// extracted by mini-css-extract-plugin
module.exports = {"tabListB":"tabListB_tabListB__WBk0c"};